import { useContext } from 'react';
import { useReducedMotion } from '../../theme/hooks.js';
import { ThemeContext } from '../../theme/ThemeProvider.js';
import type { MotionId } from '../../theme/types.js';

function allowsDecorativeIconMotion(motion: MotionId): boolean {
  return motion === 'advanced' || motion === 'rich';
}

export function useDecorativeIconMotion(active = true): boolean {
  const theme = useContext(ThemeContext);
  const reduced = useReducedMotion();
  return active && !reduced && theme !== null && allowsDecorativeIconMotion(theme.motion);
}
